import React from 'react';
import LocationTemplate from './LocationTemplate';

const BeulavillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Beulaville"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28518"]}
      latitude={34.9235}
      longitude={-77.7761}
      population={1296}
      historicalFact="Named after Beulah Baptist Church; incorporated in 1911 as a rural market town."
      nearbyTowns={[
        "Pink Hill, NC",
        "Kinston, NC",
        "Warsaw, NC",
        "Rose Hill, NC",
        "Trenton, NC",
        "Richlands, NC",
        "Kenansville, NC",
        "Mount Olive, NC"
      ]}
    />
  );
};

export default BeulavillePage;